// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"43f83f27","460":"77d8c174","778":"507e10c6"}[chunkId] + ".css";
};